"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryTooltip = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeSvg = require("react-native-svg");

var _es = require("victory-tooltip/es");

var _victoryLabel = require("./victory-label");

var _victoryPortal = require("./victory-portal/victory-portal");

var _flyout = require("./victory-primitives/flyout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var VictoryTooltip = /*#__PURE__*/function (_VictoryTooltipBase) {
  _inherits(VictoryTooltip, _VictoryTooltipBase);

  var _super = _createSuper(VictoryTooltip);

  function VictoryTooltip() {
    _classCallCheck(this, VictoryTooltip);

    return _super.apply(this, arguments);
  }

  _createClass(VictoryTooltip, [{
    key: "renderTooltip",
    value: function renderTooltip(props) {
      var evaluatedProps = this.getEvaluatedProps(props);
      var flyoutComponent = evaluatedProps.flyoutComponent,
          labelComponent = evaluatedProps.labelComponent,
          groupComponent = evaluatedProps.groupComponent,
          active = evaluatedProps.active,
          renderInPortal = evaluatedProps.renderInPortal;

      if (!active) {
        return renderInPortal ? /*#__PURE__*/_react.default.createElement(_victoryPortal.VictoryPortal, null, /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null)) : /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null);
      }

      var calculatedValues = this.getCalculatedValues(evaluatedProps);
      var children = [/*#__PURE__*/_react.default.cloneElement(flyoutComponent, this.getFlyoutProps(evaluatedProps, calculatedValues)), /*#__PURE__*/_react.default.cloneElement(labelComponent, this.getLabelProps(evaluatedProps, calculatedValues))];

      var tooltip = /*#__PURE__*/_react.default.cloneElement(groupComponent, {
        role: "presentation"
      }, children);

      return renderInPortal ? /*#__PURE__*/_react.default.createElement(_victoryPortal.VictoryPortal, null, tooltip) : tooltip;
    }
  }]);

  return VictoryTooltip;
}(_es.VictoryTooltip);

exports.VictoryTooltip = VictoryTooltip;
VictoryTooltip.defaultProps = _objectSpread(_objectSpread({}, _es.VictoryTooltip.defaultProps), {}, {
  labelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
  flyoutComponent: /*#__PURE__*/_react.default.createElement(_flyout.Flyout, null),
  groupComponent: /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null)
});

VictoryTooltip.defaultEvents = function () {
  return [{
    target: "data",
    eventHandlers: {
      onPressIn: function (targetProps) {
        return [{
          target: "labels",
          mutation: function () {
            return {
              active: true
            };
          }
        }, {
          target: "data",
          mutation: function () {
            return targetProps.activateData ? {
              active: true
            } : {
              active: undefined
            };
          }
        }];
      },
      onPressOut: function () {
        return [{
          target: "labels",
          mutation: function () {
            return {
              active: undefined
            };
          }
        }, {
          target: "data",
          mutation: function () {
            return {
              active: undefined
            };
          }
        }];
      }
    }
  }];
};